$(function() {


  /*
   * VARIABLES
   ***********************************/
  var $cursor = $('.js-cursor'),
      $icon   = $('.js-cursor-icon'),
      $action = $('.js-action'),
      iconDefault = $icon.data('default'),
      iconAction  = $icon.data('action');

  $body.on('mousemove', function(event) {
    $cursor.css('top', event.clientY);
    $cursor.css('left', event.clientX);
  });

  $action.hover(function() {
    $icon.css('background-image', 'url("' + iconAction + '")');
    $cursor.addClass('in-action');
  }, function() {
    $icon.css('background-image', 'url("' + iconDefault + '")');
    $cursor.removeClass('in-action');
  });

  $doc.ready(function() {
    $icon.css('background-image', 'url("' + iconDefault + '")');
  });

});
